import { Component, Input, OnInit } from '@angular/core';
import { NgFor, NgIf } from '@angular/common';
import { Router, RouterLink } from '@angular/router';
import { environment } from 'src/environments/environment.prod';
import { CommunicationService } from 'src/_lib/service/communication.service';
import { removeBackslash } from 'src/_lib/pipes/removebackslash.pipe';
import { CommanpageService } from 'src/_lib/service/commanpages.service';
import { BrowserService } from 'src/_lib/service/browser.service';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
  standalone: true,
  imports: [NgIf, NgFor, RouterLink, removeBackslash]
})
export class BreadcrumbComponent implements OnInit {
  @Input() breadcrumbData: { category_key: number; name: string }[] = [];
  @Input() FilterRedirectionData: any;
  commonImagePath: string = environment.commonImagePath;
  vehicle_name: string;
  chTheme1 = environment.chTheme1;

  constructor(
    private comm: CommunicationService,
    private router: Router,
    private commonService: CommanpageService,
    private browser: BrowserService
  ) { }

  ngOnInit() {
    this.comm.vehiclenameSubject.subscribe(name => {
      this.vehicle_name = name
    });
  }

  checkCategoryUrl() {
    const url = this.browser.window?.location.href;
    const parts = url.split('/');
    if (parts[4] && parts[4].startsWith('c')) {
      return true;
    } else {
      return false;
    }
  }

  onBreadcrumbClick(item: { category_key: number; name: string }): void {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.onSameUrlNavigation = 'reload';
    this.commonService.categoryRedirection(item.name, item.category_key);
  }

  slugify(name: string): string {
    return name.toLowerCase().replace(/[^a-zA-Z0-9\s]/g, '').replace(/\s+/g, '-');
  }

  onClickMMY() {
    this.router.navigate(['/parts-and-accessories']);
  }
}